(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[176],{

/***/ 6296:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Form = void 0;
const jsx_runtime_1 = __webpack_require__(5893);
const router_1 = __webpack_require__(1163);
const react_1 = __webpack_require__(7294);
const use_latest_ref_1 = __webpack_require__(9986);
const store_1 = __webpack_require__(8322);
function FormComponent(_a, ref) {
    var { method = 'post', onSubmit, onSuccess, onError } = _a, props = __rest(_a, ["method", "onSubmit", "onSuccess", "onError"]);
    const submit = (0, store_1.useFormStoreSubmit)();
    const router = (0, router_1.useRouter)();
    const onSuccessRef = (0, use_latest_ref_1.useLatestRef)(onSuccess);
    const onErrorRef = (0, use_latest_ref_1.useLatestRef)(onError);
    const handleSubmit = (event) => __awaiter(this, void 0, void 0, function* () {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
        if (event.defaultPrevented)
            return;
        event.preventDefault();
        submit({
            name: props.name,
            router,
            formData: new FormData(event.currentTarget),
            formAction: props.action || location.href.split('?')[0],
            method,
            // need to wrap the callbacks like this so the latest ref value is accessed
            // at the time the callbacks are invoked,
            // otherwise we could pass in a stale callback
            onError: (state) => {
                var _a;
                (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, state);
            },
            onSuccess: (state) => {
                var _a;
                (_a = onSuccessRef.current) === null || _a === void 0 ? void 0 : _a.call(onSuccessRef, state);
            },
        });
    });
    return (0, jsx_runtime_1.jsx)("form", Object.assign({}, props, { ref: ref, method: method, onSubmit: handleSubmit }), void 0);
}
/**
 * Replace your `form` with `Form` to submit it clientside using `fetch`, and get
 * access to the serialized form data in `usePendingSubmit()` to build a great
 * looking loading status.
 */
// the cast ensures we can use the generic on the form component
exports.Form = (0, react_1.forwardRef)(FormComponent);
//# sourceMappingURL=form.js.map

/***/ }),

/***/ 6126:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formStateWithHelpers = void 0;
function formStateWithHelpers(state) {
    return Object.assign(Object.assign({}, state), { isIdle: state.status === 'idle', isSubmitting: state.status === 'submitting', isRouting: state.status === 'routing', isLoading: state.status === 'routing' || state.status === 'submitting', isSuccess: state.status === 'success', isError: state.status === 'error' });
}
exports.formStateWithHelpers = formStateWithHelpers;
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 218:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.Zf = exports.l0 = void 0;
var form_1 = __webpack_require__(6296);
Object.defineProperty(exports, "l0", ({ enumerable: true, get: function () { return form_1.Form; } }));
var use_form_submit_1 = __webpack_require__(1271);
Object.defineProperty(exports, "Zf", ({ enumerable: true, get: function () { return use_form_submit_1.useFormSubmit; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 8322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFormStoreSubmit = exports.useFormStoreState = void 0;
const react_1 = __webpack_require__(7294);
const zustand_1 = __importDefault(__webpack_require__(4671));
const fetch_error_1 = __webpack_require__(8735);
const set_field_1 = __webpack_require__(2976);
const helpers_1 = __webpack_require__(6126);
const DEFAULT_STATE = { status: 'idle' };
const UNNAMED_FORM = Symbol('unnamed-form');
const useFormStore = (0, zustand_1.default)((set, get) => ({
    forms: {},
    setForm: (name, newState) => {
        set((state) => (Object.assign(Object.assign({}, state), { forms: Object.assign(Object.assign({}, state.forms), { [name]: newState }) })));
    },
    getForm: (name) => {
        var _a;
        return ((_a = get()) === null || _a === void 0 ? void 0 : _a.forms[name]) || DEFAULT_STATE;
    },
    submit: (options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const name = (_a = options.name) !== null && _a !== void 0 ? _a : UNNAMED_FORM;
        const { setForm, getForm } = get();
        const { status, data } = getForm(name);
        const loading = status === 'submitting' || status === 'routing';
        if (loading)
            return;
        const values = {};
        for (const [name, value] of options.formData.entries()) {
            (0, set_field_1.setField)(values, name, value);
        }
        const baseState = {
            formData: options.formData,
            values,
        };
        try {
            setForm(name, Object.assign(Object.assign({}, baseState), { status: 'submitting', data }));
            const response = yield fetchData({
                data: options.formData,
                method: options.method,
                formAction: options.formAction,
            });
            if (response.redirected) {
                const data = yield response.json();
                setForm(name, Object.assign(Object.assign({}, baseState), { status: 'routing', data }));
                yield options.router.push(response.url, undefined, { scroll: true });
                const newState = Object.assign(Object.assign({}, baseState), { status: 'success', data });
                setForm(name, newState);
                options.onSuccess((0, helpers_1.formStateWithHelpers)(newState));
                return;
            }
            if (response.ok) {
                const newState = Object.assign(Object.assign({}, baseState), { status: 'success', data: yield response.json() });
                setForm(name, newState);
                options.onSuccess((0, helpers_1.formStateWithHelpers)(newState));
                return;
            }
            const newState = Object.assign(Object.assign({}, baseState), { status: 'error', data, error: yield fetch_error_1.FetchError.create(response) });
            setForm(name, newState);
            options.onError((0, helpers_1.formStateWithHelpers)(newState));
            return;
        }
        catch (error) {
            const newState = Object.assign(Object.assign({}, baseState), { status: 'error', error: error instanceof Error ? error : new Error(String(error)), data: getForm(name).data });
            setForm(name, newState);
            options.onError((0, helpers_1.formStateWithHelpers)(newState));
        }
    }),
}));
function useFormStoreState(name) {
    return useFormStore((0, react_1.useCallback)((state) => state.forms[name !== null && name !== void 0 ? name : UNNAMED_FORM] || DEFAULT_STATE, [name]));
}
exports.useFormStoreState = useFormStoreState;
const getFormStoreSubmit = (store) => store.submit;
function useFormStoreSubmit() {
    return useFormStore(getFormStoreSubmit);
}
exports.useFormStoreSubmit = useFormStoreSubmit;
function fetchData({ method: methodArg, formAction, data, }) {
    return __awaiter(this, void 0, void 0, function* () {
        // patch must be in all caps: https://github.com/github/fetch/issues/254
        const method = methodArg.toUpperCase();
        const url = new URL(formAction, window.location.href);
        if (method !== 'GET') {
            return fetch(url.toString(), {
                method,
                headers: { accept: 'application/json' },
                body: data,
            });
        }
        for (const [field, value] of data.entries()) {
            if (typeof value === 'string') {
                url.searchParams.set(field, value);
            }
            else {
                throw new Error('Cannot submit binary form data using GET');
            }
        }
        history.replaceState(null, '', url);
        return fetch(url.toString(), {
            method,
            headers: { accept: 'application/json' },
        });
    });
}
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 1271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFormSubmit = void 0;
const react_1 = __webpack_require__(7294);
const helpers_1 = __webpack_require__(6126);
const store_1 = __webpack_require__(8322);
function useFormSubmit(name) {
    const state = (0, store_1.useFormStoreState)(name);
    return (0, react_1.useMemo)(() => (0, helpers_1.formStateWithHelpers)(state), [state]);
}
exports.useFormSubmit = useFormSubmit;
//# sourceMappingURL=use-form-submit.js.map

/***/ }),

/***/ 8735:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FetchError = void 0;
class FetchError extends Error {
    constructor(response, data) {
        super(`[${response.status}]: ${response.statusText}`);
        this.status = response.status;
        this.statusText = response.statusText;
        this.headers = response.headers;
        this.data = data;
    }
    static create(response) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const data = ((_a = response.headers
                .get('content-type')) === null || _a === void 0 ? void 0 : _a.startsWith('application/json'))
                ? yield response.json()
                : undefined;
            return new FetchError(response, data);
        });
    }
}
exports.FetchError = FetchError;
//# sourceMappingURL=fetch-error.js.map

/***/ }),

/***/ 9986:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLatestRef = void 0;
const react_1 = __webpack_require__(7294);
/**
 * Helpful when we want to use a value in an effect or useCallback,
 * but don't want to react to changes
 */
function useLatestRef(value) {
    const ref = (0, react_1.useRef)(value);
    (0, react_1.useEffect)(() => {
        ref.current = value;
    }, [value]);
    return ref;
}
exports.useLatestRef = useLatestRef;
//# sourceMappingURL=use-latest-ref.js.map

/***/ }),

/***/ 2976:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setField = void 0;
function setField(data, name, value) {
    // a[b][c] becomes [ a, b, c ]
    const path = name.replace(/\[([^\]]+)?]/g, '.$1').split('.');
    let pointer = data;
    // walk the path, and create objects and arrays where required
    for (let i = 0; i < path.length - 1; i++) {
        // empty strings and numeric values, indicate arrays
        pointer[path[i]] =
            pointer[path[i]] || (/^$|^[0-9]*$/.test(path[i + 1]) ? [] : {});
        pointer = pointer[path[i]];
    }
    const key = path[path.length - 1];
    if (Array.isArray(pointer)) {
        pointer.push(value);
    }
    else if (Array.isArray(pointer[key])) {
        pointer[key].push(value);
    }
    else if (typeof pointer[key] !== 'undefined') {
        pointer[key] = [pointer[key], value];
    }
    else {
        pointer[key] = value;
    }
    return data;
}
exports.setField = setField;
//# sourceMappingURL=set-field.js.map

/***/ }),

/***/ 2339:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin",
      function () {
        return __webpack_require__(5849);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ SignIn; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/PaperAirplaneIcon.js


function PaperAirplaneIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
  }));
}

const ForwardRef = react.forwardRef(PaperAirplaneIcon);
/* harmony default export */ var esm_PaperAirplaneIcon = (ForwardRef);
// EXTERNAL MODULE: ./node_modules/next-runtime/form/index.js
var next_runtime_form = __webpack_require__(218);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(4931);
;// CONCATENATED MODULE: ./pages/signin.tsx




var __N_SSP = true;
function SignIn() {
    var isLoading = (0,next_runtime_form/* useFormSubmit */.Zf)("signin").isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-md w-full space-y-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "mx-auto h-12 w-auto",
                            src: "https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg",
                            alt: "Workflow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "mt-6 text-center text-3xl font-extrabold text-gray-900",
                            children: "Sign in with your email below"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(next_runtime_form/* Form */.l0, {
                    name: "signin",
                    className: "mt-8 space-y-6",
                    method: "post",
                    encType: "multipart/form-data",
                    onSuccess: function() {
                        react_hot_toast_esm/* default.success */.ZP.success("Check your email for the login link!");
                    },
                    onError: function(param) {
                        var error = param.error;
                        var ref;
                        var _message;
                        react_hot_toast_esm/* default.error */.ZP.error((_message = (ref = error) === null || ref === void 0 ? void 0 : ref.data.message) !== null && _message !== void 0 ? _message : "Unable to send magic link");
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "rounded-md shadow-sm -space-y-px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "email-address",
                                        className: "sr-only",
                                        children: "Email address"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: "email-address",
                                        name: "email",
                                        type: "email",
                                        autoComplete: "email",
                                        required: true,
                                        className: "appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm",
                                        placeholder: "Email address"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "submit",
                                className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                                disabled: isLoading,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "absolute left-0 inset-y-0 flex items-center pl-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_PaperAirplaneIcon, {
                                            className: "h-5 w-5 text-blue-300 group-hover:text-blue-400",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    isLoading ? "Loading..." : "Send magic link"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 4671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ create; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function create$1(createState) {
  let state;
  const listeners = new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribeWithSelector = (listener, selector = getState, equalityFn = Object.is) => {
    console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
    let currentSlice = selector(state);
    function listenerToAdd() {
      const nextSlice = selector(state);
      if (!equalityFn(currentSlice, nextSlice)) {
        const previousSlice = currentSlice;
        listener(currentSlice = nextSlice, previousSlice);
      }
    }
    listeners.add(listenerToAdd);
    return () => listeners.delete(listenerToAdd);
  };
  const subscribe = (listener, selector, equalityFn) => {
    if (selector || equalityFn) {
      return subscribeWithSelector(listener, selector, equalityFn);
    }
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(setState, getState, api);
  return api;
}

const isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
const useIsomorphicLayoutEffect = isSSR ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
function create(createState) {
  const api = typeof createState === "function" ? create$1(createState) : createState;
  const useStore = (selector = api.getState, equalityFn = Object.is) => {
    const [, forceUpdate] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((c) => c + 1, 0);
    const state = api.getState();
    const stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    const selectorRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(selector);
    const equalityFnRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(equalityFn);
    const erroredRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const currentSliceRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    if (currentSliceRef.current === void 0) {
      currentSliceRef.current = selector(state);
    }
    let newStateSlice;
    let hasNewStateSlice = false;
    if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
      newStateSlice = selector(state);
      hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
    }
    useIsomorphicLayoutEffect(() => {
      if (hasNewStateSlice) {
        currentSliceRef.current = newStateSlice;
      }
      stateRef.current = state;
      selectorRef.current = selector;
      equalityFnRef.current = equalityFn;
      erroredRef.current = false;
    });
    const stateBeforeSubscriptionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    useIsomorphicLayoutEffect(() => {
      const listener = () => {
        try {
          const nextState = api.getState();
          const nextStateSlice = selectorRef.current(nextState);
          if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
            stateRef.current = nextState;
            currentSliceRef.current = nextStateSlice;
            forceUpdate();
          }
        } catch (error) {
          erroredRef.current = true;
          forceUpdate();
        }
      };
      const unsubscribe = api.subscribe(listener);
      if (api.getState() !== stateBeforeSubscriptionRef.current) {
        listener();
      }
      return unsubscribe;
    }, []);
    return hasNewStateSlice ? newStateSlice : currentSliceRef.current;
  };
  Object.assign(useStore, api);
  useStore[Symbol.iterator] = function() {
    console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
    const items = [useStore, api];
    return {
      next() {
        const done = items.length <= 0;
        return { value: items.shift(), done };
      }
    };
  };
  return useStore;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2339); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);